import styled from "styled-components";

export const WrapperHeaderProfile = styled.h1`
    color: #000;
    font-size: 24px;
    padding: 24px 0;
    text-align: center;
`

export const WrapperContentProfile = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
    width: 800px;
    gap: 10px;
    padding: 48px;
    border-radius: 12px;
    margin-left: 200px
`

